const COLORS = {
  trend: { fill: "rgba(34, 197, 94, 0.10)", text: "rgba(134, 239, 172, 0.9)" },
  range: { fill: "rgba(245, 158, 11, 0.12)", text: "rgba(253, 230, 138, 0.92)" },
  highVol: { fill: "rgba(168, 85, 247, 0.13)", text: "rgba(216, 180, 254, 0.94)" },
  transition: { fill: "rgba(148, 163, 184, 0.08)", text: "rgba(203, 213, 225, 0.82)" },
};

class EfficiencyRegimeRenderer {
  constructor(source) {
    this.source = source;
  }

  draw(target) {
    const { chart, bars } = this.source;
    if (!chart || !bars.length) return;

    target.useMediaCoordinateSpace(({ context, mediaSize }) => {
      const timeScale = chart.timeScale();
      const spacing = Math.max(1, timeScale.options().barSpacing || 5);
      const runs = [];
      bars.forEach((bar) => {
        const x = timeScale.timeToCoordinate(bar.time);
        if (x == null || x < -spacing || x > mediaSize.width + spacing) return;
        const left = x - spacing / 2;
        const right = x + spacing / 2;
        const previous = runs[runs.length - 1];
        if (previous?.kind === bar.kind && left <= previous.right + spacing * 0.6) {
          previous.right = right;
        } else {
          runs.push({ kind: bar.kind, left, right });
        }
      });

      runs.forEach((run) => {
        const color = COLORS[run.kind];
        const left = Math.max(0, run.left);
        const right = Math.min(mediaSize.width, run.right);
        if (right <= left) return;
        context.fillStyle = color.fill;
        context.fillRect(left, 0, right - left, mediaSize.height);
        if (right - left >= 76) {
          context.fillStyle = color.text;
          context.font = "600 10px system-ui, sans-serif";
          context.textAlign = "center";
          context.textBaseline = "top";
          const label = run.kind === "highVol" ? "HIGH VOL" : run.kind === "trend" ? "TREND" : run.kind === "range" ? "RANGE" : "MIXED";
          context.fillText(label, (left + right) / 2, 8);
        }
      });

      const holdoutStart = bars.find((bar) => bar.phase === "holdout");
      const holdoutX = holdoutStart ? timeScale.timeToCoordinate(holdoutStart.time) : null;
      if (holdoutX != null && holdoutX >= 0 && holdoutX <= mediaSize.width) {
        context.save();
        context.strokeStyle = "rgba(248, 250, 252, 0.72)";
        context.lineWidth = 1;
        context.setLineDash([4, 4]);
        context.beginPath();
        context.moveTo(holdoutX, 0);
        context.lineTo(holdoutX, mediaSize.height);
        context.stroke();
        context.setLineDash([]);
        context.fillStyle = "rgba(248, 250, 252, 0.82)";
        context.font = "600 9px system-ui, sans-serif";
        context.textAlign = "left";
        context.textBaseline = "top";
        context.fillText("HOLDOUT", Math.min(holdoutX + 5, mediaSize.width - 58), 8);
        context.restore();
      }
    });
  }
}

export class EfficiencyRegimePrimitive {
  constructor() {
    this.chart = null;
    this.bars = [];
    this.requestUpdate = null;
    this.views = [{ zOrder: () => "top", renderer: () => new EfficiencyRegimeRenderer(this) }];
  }

  attached({ chart, requestUpdate }) {
    this.chart = chart;
    this.requestUpdate = requestUpdate;
  }

  detached() {
    this.chart = null;
    this.requestUpdate = null;
  }

  paneViews() {
    return this.views;
  }

  setState({ bars }) {
    this.bars = bars || [];
    this.requestUpdate?.();
  }
}
